import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FontIcon from 'components/FontIcon';
import classes from './ExpandableListItemB.module.scss';

const ExpandableListItemB = (props) => {
  const {
    title,
    body,
    onClick,
    showBody,
  } = props;

  if (!title || !body) {
    return null;
  }

  const arrowClassName = showBody ? classes.iconWrapperOpen : classes.iconWrapperClosed;

  return (
    <div className={classes.container}>
      <button aria-label='Toggle' className={classes.toggle} onClick={onClick} type='button'>
        <h5
          className={classes.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className={arrowClassName}>
          <FontIcon
            className={classes.icon}
            icon='far fa-angle-down'
          />
        </div>
      </button>
      <div
        className={classNames(classes.body, showBody ? '' : classes.hide)}
        dangerouslySetInnerHTML={{ __html: body }}
      />
    </div>
  );
};

ExpandableListItemB.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  onClick: PropTypes.func,
  showBody: PropTypes.bool,
};

export default ExpandableListItemB;
